// One position as % of NAV against the D080 per-position cap. Numbers are always visible as text.
interface Props {
  ticker: string
  pctNav: number
  capPct: number | null
}

export function CapMeter({ ticker, pctNav, capPct }: Props) {
  const max = capPct != null ? Math.max(capPct * 1.25, pctNav * 1.05) : Math.max(pctNav * 1.25, 1)
  const fill = Math.min(100, (pctNav / max) * 100)
  const tick = capPct != null ? Math.min(100, (capPct / max) * 100) : null
  const over = capPct != null && pctNav > capPct + 0.005
  const text = capPct != null
    ? `${pctNav.toFixed(2)}% NAV of ${capPct.toFixed(2)}% cap${over ? ', over cap' : ''}`
    : `${pctNav.toFixed(2)}% NAV, cap unavailable`
  return (
    <div className="strat-meter-row">
      <span className="strat-meter-ticker">{ticker}</span>
      <div
        className={`strat-meter${over ? ' strat-meter--over' : ''}`}
        role="meter"
        aria-label={`${ticker} position size against cap`}
        aria-valuemin={0}
        aria-valuemax={Number(max.toFixed(2))}
        aria-valuenow={Number(pctNav.toFixed(2))}
        aria-valuetext={text}
      >
        <div className="strat-meter-fill" style={{ width: `${fill}%` }} />
        {tick != null && <div className="strat-meter-tick" style={{ left: `${tick}%` }} aria-hidden="true" />}
      </div>
      <span className="strat-meter-text">{text}</span>
    </div>
  )
}
